var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5448",
    "data-name": "Group 5448",
    transform: "translate(-4348 -5707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "caret-down",
    d: "M.58,0H8.042a.579.579,0,0,1,.409.989L4.722,4.721a.581.581,0,0,1-.821,0L.171.989A.579.579,0,0,1,.58,0Z",
    transform: "translate(4361.586 5717.873) rotate(-135)",
    fill: "#a6acb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caret-down-2",
    "data-name": "caret-down",
    d: "M.58,0H8.042a.579.579,0,0,1,.409.989L4.722,4.721a.581.581,0,0,1-.821,0L.171.989A.579.579,0,0,1,.58,0Z",
    transform: "translate(4353.34 5713.926) rotate(45)",
    fill: "#a6acb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16113",
    "data-name": "Rectangle 16113",
    width: 18,
    height: 18,
    transform: "translate(4348 5707)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.ca1594e4f49ff73aefaf78935a16f756.svg";
export { ForwardRef as ReactComponent };